import { BehaviorSubject, Observable } from 'rxjs';
import { NzI18nService } from 'ng-zorro-antd/i18n';
import { enUS as en, ru, kk, zhCN as zh } from 'date-fns/locale';
import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({ // Add the @Injectable() decorator
  providedIn: 'root'  // This means the service is provided globally
})
export class LangSwitcherService {
  private activeLang: BehaviorSubject<any>;

  constructor(@Inject(DOCUMENT) private document: Document, private i18n: NzI18nService) {
    this.activeLang = new BehaviorSubject<any>({});
  }

  getActiveLang(): Observable<any> {
    return this.activeLang.asObservable();
  }

  setActiveLang(value: string): void {
    this.document.documentElement.lang = value === 'kz' ? 'kk' : value;
    localStorage.setItem('lang', value);
    localStorage.setItem('appLocale', value);
    this.activeLang.next(value);
    switch (value) {
      case 'ru': {
        this.i18n.setDateLocale(ru);
        break;
      }
      case 'en': {
        this.i18n.setDateLocale(en);
        break;
      }
      case 'kz': {
        this.i18n.setDateLocale(kk);
        break;
      }
      case 'zh': {
        localStorage.setItem('lang', 'ru');
        localStorage.setItem('appLocale', 'zh');
        this.i18n.setDateLocale(zh);
        break;
      }
      default: {
        this.i18n.setDateLocale(ru);
        break;
      }
    }
  }

  getActiveLangFromStorage(): string {
    const lang = localStorage.getItem('lang');
    const appLocale = localStorage.getItem('appLocale');
    console.log('lang', lang, 'appLocale', appLocale);
    return appLocale ? appLocale : lang ? lang : 'ru';
  }
}
